import React from "react";
import Select from "react-select";
import { AssignPageField, FormField } from "../../common/FormFields";

const HeaderButtonBlock = ({ buttonConfig, formik, headerButtonTypeArr, isLast }) => {
  const buttonType = formik.values[buttonConfig.typeField];
  const isShown = formik.values[buttonConfig.visibilityField] === 1;

  const renderTargetField = () => {
    switch (buttonType) {
      case 2:
        return (
          <FormField
            field={{ name: buttonConfig.urlField, label: "Custom Link URL" }}
            formik={formik}
            required={false}
            col_md={6}
            col_lg={3}
            placeholder="Enter Custom Link URL"
          />
        );
      case 0:
        return (
          <AssignPageField
            name={buttonConfig.assignedField}
            label="Assigned Page for Button"
            formik={formik}
            dataTarget={`#${buttonConfig.pageModalId}`}
            assignedPage={buttonConfig.assignedPopupPages}
            setAssignedPage={buttonConfig.setAssignedPopupPages}
            required
          />
        );
      case 1:
        return (
          <AssignPageField
            name={buttonConfig.assignedField}
            label="Assigned Qualification for Button"
            formik={formik}
            dataTarget={`#${buttonConfig.qualModalId}`}
            assignedPage={buttonConfig.assignedQualification}
            setAssignedPage={buttonConfig.setAssignedQualification}
            buttonName="Assign Qualification"
            required
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className={`col-md-12${isLast ? "" : " mb-4"}`}>
      <div className="row align-items-start">
        <div
          style={{
            flex: "0 0 auto",
            maxWidth: "none",
            paddingLeft: "15px",
            paddingRight: "24px",
            width: "auto",
          }}
        >
          <div className="form-group-blk mb-3">
            <label className="font-weight-bold">
              Button {buttonConfig.idx}
              {buttonConfig.idx > 1 ? <small className="text-muted ml-2">(optional)</small> : null}
            </label>
            <div className="d-flex align-items-center" style={{ minHeight: "42px" }}>
              <label className="mb-0 mr-2">Show Button</label>
              <div className="toggle-switch">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={isShown}
                    onChange={(e) =>
                      formik.setFieldValue(buttonConfig.visibilityField, e.target.checked ? 1 : 0)
                    }
                  />
                  <span className="slider slider-round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="form-group-blk mb-3" title="Header Button Type">
            <label>
              Header Button Type <i className="fal fa-info-circle"></i>
            </label>
            <Select
              className={
                "form-control custom-select-box" +
                (formik.errors[buttonConfig.typeField] && formik.touched[buttonConfig.typeField] ? " is-invalid" : "")
              }
              name={buttonConfig.typeField}
              value={
                buttonType !== "" && buttonType !== undefined && buttonType !== null
                  ? headerButtonTypeArr.find((option) => option?.value === buttonType) || null
                  : null
              }
              onChange={(option) => {
                formik.setFieldValue(buttonConfig.typeField, option ? Number(option.value) : "");
              }}
              onBlur={formik.handleBlur}
              options={headerButtonTypeArr}
              maxMenuHeight={175}
              placeholder="Header Button Type"
              isClearable
            />
          </div>
        </div>
        <FormField
          field={{ name: buttonConfig.textField, label: "Header Button Text", requiredField: isShown }}
          formik={formik}
          col_md={6}
          col_lg={3}
          placeholder="Enter Button Text"
        />
        {renderTargetField()}
      </div>
    </div>
  );
};

export default HeaderButtonBlock;
